import axios from '../../config/axios';
import getEnv from '../getEnv';

interface ILogin {
  email: string;
  password: string;
}

interface IToken {
  access_token: string;
  refresh_token: string;
  token_type: string;
  expires_in: number;
}

interface IAccessToken {
  hash: string | null;
  grantType: string;
  type: string;
}

/**
 * Login flow explanation:
 * https://docs.sensedia.com/en/api-platform-guide/4.2.x.x/other-info/oauth20.html
 */
export async function generateAuthorizationCode(
  clientId: string,
): Promise<string> {
  try {
    const url = getEnv('auth-code');
    const response = await axios.post(url, {
      client_id: clientId,
      redirect_uri: 'http://localhost/',
    });

    const redirectUri = response?.data?.redirect_uri;
    return redirectUri.split('code=')[1];
  } catch (e) {
    const { error } = e?.response?.data;
    throw { messages: error };
  }
}

// Mandatory headers: Authorization and client_id
export async function generateAccessToken({
  hash,
  grantType,
  type,
}: IAccessToken): Promise<IToken> {
  try {
    const url = getEnv('access-token');
    const response = await axios.post(url, {
      grant_type: grantType,
      [type]: hash,
    });

    return response?.data;
  } catch (e) {
    const { error } = e?.response?.data;
    throw { messages: error };
  }
}

// Mandatory headers: client_id and access_token
export default async function login({
  email,
  password,
}: ILogin): Promise<void> {
  try {
    const url = getEnv('auth-user');

    const response = await axios.post(url, {
      email,
      password,
    });
    const token = response?.data?.access_token;

    return token;
  } catch (e) {
    const { error } = e?.response?.data;
    throw { messages: error };
  }
}
